import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  CENTER_LABEL: `${cleanedFilename(__filename)}-center-label`,
  LEGEND_ITEM: `${cleanedFilename(__filename)}-legend-item`,
};
